import { NgModule } from "@angular/core"
import { MatExpansionModule } from "@angular/material/expansion"
import { RouterModule } from "@angular/router"
import { BlogCardComponentModule } from "@component/generic/cards/blog-card/blog-card.component"
import { JobCardComponentModule } from "@component/generic/cards/job-card/job-card.component"
import { CreatePanelComponent } from "@component/generic/create-panel/create-panel.component"
import { HeadlineComponent } from "@component/generic/headline/headline.component"
import { ImageSliderComponentModule } from "@component/generic/image-slider/image-slider.component"
import { PartnerSliderComponent } from "@component/generic/partner-slider/partner-slider.component"
import { NewsComponent } from "@component/news/news.component"
import { AdvertGridItemModule } from "@component/shared/advert-grid-item/advert-grid-item.component"
import { SharedModule } from "./shared.module"
import { GoToLinkComponent } from "@component/generic/go-to-link/go-to-link.component"
import { NewsfeedTopBannerComponent } from "@component/generic/newsfeed-top-banner/newsfeed-top-banner.component"
import { CreateEntryButtonComponentModule } from "@component/generic/create-entry-button/create-entry-button.module"
import { NewsfeedBottomBannerComponent } from "@component/generic/newsfeed-bottom-banner/newsfeed-bottom-banner.component"

@NgModule({
  declarations: [
    NewsComponent,
    PartnerSliderComponent,
    CreatePanelComponent,
    HeadlineComponent,
    GoToLinkComponent,
    NewsfeedTopBannerComponent,
    NewsfeedBottomBannerComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: "",
        data: {
          title: 'Newsfeed | Zimmerer-Treffpunkt',
        },
        component: NewsComponent
      },
    ]),

    AdvertGridItemModule,
    ImageSliderComponentModule,
    JobCardComponentModule,
    BlogCardComponentModule,

    MatExpansionModule,
    CreateEntryButtonComponentModule
  ],
  exports: [
    NewsComponent,
    PartnerSliderComponent,
    CreatePanelComponent,
    HeadlineComponent,

    SharedModule,
    AdvertGridItemModule,
    ImageSliderComponentModule,
    JobCardComponentModule,
    BlogCardComponentModule,

    MatExpansionModule,
  ]
})
export class NewsModule { }